import React, { useState } from 'react';
import styles from './style.module.css';
import { useEffect } from 'react';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import { Button } from '../../../Components';
import Modal from 'react-modal';
import EffectsReportFilterTool from '../../../Components/ReportFilterTool/EffectsReportFilterTool';
import ModalStatus from '../../../Components/ReportFilterTool/ModalStatus';

import HealthHeader from '../../../Components/HealthHeader';
import HealthCards from '../../../Components/HealthCard';
import HealthPatientStatsTable from '../../../Components/HealthPatientStatsTable';
import { getEffectsMetrics } from '../../../services/kollectaHealthCore';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalFeedback, setModalFeedback] = useState(false);
  const [statisticsData, setStatisticsData] = useState(null);

  const closeFiltersModal = () => {
    setModal(false);
  }

  const closeStatusModal = () => {
    setModal(false);
    setModalFeedback(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getEffectsMetrics();
        setStatisticsData(data?.data);
      } catch (error) {
        console.error('Erro ao buscar os dados de efeitos adversos:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  const data = [
    { value: statisticsData?.uniqueEffectsPatients || 0, label: 'PACIENTES CADASTRADOS' },
    { value: `${statisticsData?.botHistoryMetrics?.percentage || '0.00'}%`, label: 'ÍNDICE DE ADESÃO AO ESTUDO' }
  ];

  const headers = ['PACIENTES', 'CONTAGEM', 'ÍNDICE'];

  const tableData = [
    {
      description: 'Pacientes que apresentaram efeitos leves',
      count: statisticsData?.effectsLevelMetrics?.mild?.total || 0,
      percentage: `${statisticsData?.effectsLevelMetrics?.mild?.percentage || '0.00'}%`,
      color: '#266400'
    },
    {
      description: 'Pacientes que apresentaram efeitos moderados',
      count: statisticsData?.effectsLevelMetrics?.moderate?.total || 0,
      percentage: `${statisticsData?.effectsLevelMetrics?.moderate?.percentage || '0.00'}%`,
      color: '#786C00'
    },
    {
      description: 'Pacientes que apresentaram efeitos graves',
      count: statisticsData?.effectsLevelMetrics?.severe?.total || 0,
      percentage: `${statisticsData?.effectsLevelMetrics?.severe?.percentage || '0.00'}%`,
      color: '#B41411'
    },
  ];

  const totalData = 
  {
    description: 'Total de pacientes que apresentaram algum efeito adverso',
    count: statisticsData?.effectsLevelMetrics?.anyEffects?.total || 0,
    percentage: `${statisticsData?.effectsLevelMetrics?.anyEffects?.percentage || '0.00'}%`,
    color: '#FFFFFF'
  }

  const noEffectsData = 
  {
    description: 'Pacientes que não apresentaram efeitos adversos',
    count: statisticsData?.effectsLevelMetrics?.noEffects?.total || 0,
    percentage: `${statisticsData?.effectsLevelMetrics?.noEffects?.percentage || '0.00'}%`,
    color: '#FFFFFF'
  }

	return (
    <div className={styles.container}>
      <LoadingOverlay isLoading={loading} />
      <HealthHeader title="Dashboard de Pacientes" />
      <div className={styles.content}>
        <div className={styles.buttonContainer}>
          <Button onClick={() => setModal(true)}>Exportar Relatório</Button>
        </div>
        <HealthCards items={data} />
        <HealthPatientStatsTable 
          header={headers} 
          data={tableData} 
          totalData={totalData}
          noPainData={noEffectsData}
        />
      </div>

      {!modalFeedback && 
        <Modal
          isOpen={modal}
          onRequestClose={closeFiltersModal}
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
            },
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '8px',
              width: '615px',
            },
          }}
        > 
          <div className={styles.modalContainer}>
            <EffectsReportFilterTool closeModal={closeFiltersModal} setFeedback={setModalFeedback} />
          </div>
        </Modal>  
      }

      <ModalStatus type={modalFeedback} onClose={closeStatusModal} />
    </div>
	)
}

export default Home;
